export default __webpack_public_path__ + "static/media/doc.80b21045.svg";